import { withErrorBoundary } from 'react-error-boundary';
import type { TypeBrandSliderDetailed } from 'types/autogen/contentful';
import type { ResponsiveImageLinkModel } from 'autogen/swagger/all';
import BrandSlider from 'components/brandSlider';
import { isNotUndefined } from 'helpers/filterHelpers';
import WhenCFPreview from '../../shared/WhenCFPreview';

function BrandSliderRenderer(props: TypeBrandSliderDetailed) {
    const {
        fields: { brands, trackingProperties },
        sys: { id }
    } = props;
    if (!brands) return null;

    const logos = brands.map((x) => x.logo).filter<ResponsiveImageLinkModel>(isNotUndefined);

    return (
        <WhenCFPreview id={id}>
            <BrandSlider brandLogos={logos} promoTracking={trackingProperties?.fields} />
        </WhenCFPreview>
    );
}

export default withErrorBoundary(BrandSliderRenderer, {
    fallback: null,
    onError(error, info) {
        console.error(error, info);
    }
});
